import React from 'react';
import { Box, Typography, Button, Container, Paper, Grid } from '@mui/material';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import ExploreIcon from '@mui/icons-material/Explore';
import MapIcon from '@mui/icons-material/Map';
import SaveIcon from '@mui/icons-material/Save';
import logo from '../assets/favicon_t.png';
import screenshot from '../assets/map.png'

const HomePageContainer = styled(Box)`
  min-height: 100vh;
  background-color: #fefefe;
  display: flex;
  flex-direction: column;
`;

const HeroSection = styled(Box)`
  background: linear-gradient(to right, rgb(228, 241, 241), rgb(241, 247, 251));
  padding: 64px 24px;
  text-align: center;
`;

const FeatureCard = styled(Paper)`
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
  flex: 1 1 300px; /* allow flexible growth/shrink and base width */
  max-width: 400px;
  margin: 12px;
`;

interface NavBarLoggedOutViewProps {
  onSignUpClicked: () => void;
  onLoginClicked: () => void;
}

const NotesPageLoggedOutView = ({ onSignUpClicked, onLoginClicked }: NavBarLoggedOutViewProps) => {
  const navigate = useNavigate();

  return (
    <HomePageContainer>
<HeroSection>
  <Container maxWidth="xl">
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        gap: 4,
        textAlign: { xs: "center", md: "left" },
      }}
    >
      {/* Left Side */}
      <Box sx={{ flex: 1 }}>
        <Typography variant="h2" fontWeight={700} gutterBottom>
          Magellan Maps
        </Typography>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Car Routes, Reimagined
        </Typography>
        <Typography variant="h6" color="textSecondary" gutterBottom>
          Inspired by Ferdinand Magellan — the first to sail around the world — Magellan Maps brings the explorer’s mindset to your road trips. Describe the kind of drive you want, and we’ll generate a unique, optimised route for your car.
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          Whether you're planning a scenic detour or a direct drive, export routes to GPX, open them in Google Maps, or just hit the road. Let your words steer the wheel.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          style={{ backgroundColor: "black", borderColor: "white", outlineColor: "white" }}
          size="large"
          onClick={() => onSignUpClicked()}
          sx={{ mt: 4, px: 5, py: 1.5 }}
        >
          Get Started For Free
        </Button>
      </Box>

      {/* Right Side */}
<Box
  sx={{
    flex: 1,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }}
>
  <Box
    sx={{
      position: "relative",
      width: "100%",
      maxWidth: '80%',
    }}
  >
    <img
      src={screenshot}
      alt="Illustrative Route Map"
      style={{
        width: "100%",
        height: "auto",
        borderRadius: '8px',
        transform: 'skewX(-3deg) skewY(1deg)',
        boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
      }}
    />
    <Box
      sx={{
        position: "absolute",
        bottom: 12,
        left: 12,
        // backgroundColor: "rgba(0, 0, 0, 0.6)",
        padding: "8px 12px",
        borderRadius: "6px",
        maxWidth: "85%",
      }}
    >
      {/* <Typography variant="subtitle2" color="white">
        “Plan me a road trip from London to Polzeath, avoiding all motorways and stopping at 4 places to enjoy the scenery.”
      </Typography> */}
    </Box>
  </Box>
</Box>

    </Box>
  </Container>
</HeroSection>



      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h4" textAlign="center" fontWeight={600} gutterBottom>
          What Do We Offer?
        </Typography>

        {/* Flexbox container replacing Grid */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 4,
            mt: 2,
          }}
        >
          <FeatureCard>
            <ExploreIcon color="primary" fontSize="large" />
            <Typography variant="h6" fontWeight={600} mt={1}>
              AI-Powered Exploration
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Describe your dream route and let our AI map it out instantly.
            </Typography>
          </FeatureCard>

          <FeatureCard>
            <MapIcon color="primary" fontSize="large" />
            <Typography variant="h6" fontWeight={600} mt={1}>
              Visualize on the Map
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Preview every generated route in an interactive, high-accuracy map.
            </Typography>
          </FeatureCard>

          <FeatureCard>
            <SaveIcon color="primary" fontSize="large" />
            <Typography variant="h6" fontWeight={600} mt={1}>
              Save and Reuse
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Save your favorite routes to your account for quick access later.
            </Typography>
          </FeatureCard>
        </Box>
      </Container>
    </HomePageContainer>
  );
};

export default NotesPageLoggedOutView;
